// extracted by mini-css-extract-plugin
export default {"backgroundwhite":"SimpleText-module--backgroundwhite--1ARRX","backgroundgray":"SimpleText-module--backgroundgray--9giOL","simpleBlock":"SimpleText-module--simpleBlock--eUG1L"};